import { Component, ViewChild } from '@angular/core';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { ContainerWorkflowDialogContent, DataCheck } from '../../../workflow.dialog';
import { ABaseContainerSettingsData } from '../container.chooser';

@Component({
    selector: 'wf-execute-read-settings',
    templateUrl: './execute.read.settings.html'
})
export class ExecuteReadSettings extends ContainerWorkflowDialogContent {
    Data = new ExecuteReadSettingsData();
    @ViewChild('chooser') ContainerChooser;
    DBUsages = [[4096, 16]]; // RelationalRead oder DocumentStoreRead

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'executeReadWFModule';
        reg.Caption = '@@Read';
        reg.GroupID = 'containeroperations';
        reg.Index = 40;
        reg.SettingsControl = ExecuteReadSettings;
        reg.SettingsTypeHelper = new ExecuteReadSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, ExecuteReadSettingsData);
        }
    }

    checkData(): DataCheck {
        const retVal = new DataCheck();
        if (!this.Data.ContainerTable) {
            retVal.IsCorrect = false;
            retVal.Error = '@@Bitte waehlen Sie eine Tabelle';
        }
        return retVal;
    }

    getResult(): any {
        if (this.Data.InteractiveProperties) {
            this.Data.InteractiveProperties = this.Data.InteractiveProperties.filter(x => x.Value);
        }
        if (this.Data.ContainerTable && this.ContainerChooser) {
            this.ContainerChooser.CheckActualFilter();
        }
        return this.Data;
    }
}

export class ExecuteReadSettingsData extends ABaseContainerSettingsData {
}

export class ExecuteReadSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new ExecuteReadSettingsData();
    }
}
